import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {ProviderServiceModel} from '../providerService.model';
import {ProviderServiceSummaryConverter} from './providerServiceSummary.converter';
import {ProviderServiceCoveringConverter} from "./providerServiceCovering.converter";

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceConverter extends HttpModelConverter<ProviderServiceModel> {

    constructor(private providerServiceSummaryConverter: ProviderServiceSummaryConverter,
                private providerServiceCoveringConverter : ProviderServiceCoveringConverter) {
        super();
    }

    protected createInstance(): ProviderServiceModel {
        return new ProviderServiceModel();
    }

    protected enrichObject(result: ProviderServiceModel, src: ProviderServiceModel) {
        result.summary = this.providerServiceSummaryConverter.convert(src.summary);
        result.coverings = this.providerServiceCoveringConverter.convertFromArray(src.coverings);
    }
}
